export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"charset":"utf-8"}],"link":[{"rel":"stylesheet","type":"text/css","href":"/assets/css/global.css"}],"style":[],"script":[{"hid":"crisp","type":"text/javascript","innerHTML":"\n            /* window.$crisp=[];\n            window.CRISP_WEBSITE_ID=\"307a66bb-5356-46bd-90c6-a6c9e7f4852d\";\n            (function(){\n              d=document;\n              s=d.createElement(\"script\");\n              s.src=\"https://client.crisp.chat/l.js\";\n              s.async=1;\n              d.getElementsByTagName(\"head\")[0].appendChild(s);\n            })();\n            window.$crisp.push(['do', 'chat:show']); */\n          "},{"hid":"cookieyes","id":"cookieyes","type":"text/javascript","src":"https://cdn-cookieyes.com/client_data/8b4aca5b682bdcf34bf786e3/script.js","async":false},{"hid":"facebook-pixel","type":"text/javascript","innerHTML":"\n      !function(f,b,e,v,n,t,s)\n      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n      n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n      n.queue=[];t=b.createElement(e);t.async=!0;\n      t.src=v;s=b.getElementsByTagName(e)[0];\n      s.parentNode.insertBefore(t,s)}(window, document,'script',\n      'https://connect.facebook.net/en_US/fbevents.js');\n      fbq('init', 'undefined');\n      fbq('track', 'PageView');\n    "}],"noscript":[{"hid":"facebook-pixel-noscript","innerHTML":"\n      <img height=\"1\" width=\"1\" style=\"display:none\"\n           src=\"https://www.facebook.com/tr?id=undefined&ev=PageView&noscript=1\"/>\n    "}],"htmlAttrs":{"lang":"pt","class":"light","style":"color-scheme: light"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no","bodyAttrs":{"class":"overflow-x-hidden font-body text-jacarta-500 dark:bg-jacarta-900"},"__dangerouslyDisableSanitizersByTagID":{"crisp":["innerHTML"],"facebook-pixel":["innerHTML"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'